export const YEAR = 'YEAR';
export const MONTH = 'MONTH';
export const DAY = 'DAY';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/DateTimePicker/DateComponents/DateConstants.js